import React from 'react';
import './Pagination.css';
function Pagination({ currentPage, totalPages, onPageChange }) {
    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            onPageChange(newPage);
        }
    };

    return (
        <div className="pagination">
            {currentPage > 5 && (
                <button onClick={() => handlePageChange(currentPage - 5)}>
                    前五頁
                </button>
            )}
            {currentPage > 1 && (
                <button onClick={() => handlePageChange(currentPage - 1)}>
                    上一頁
                </button>
            )}
            {[...Array(5)].map((_, index) => {
                const pageNumber = currentPage + index - 2;
                return (
                    pageNumber > 0 && pageNumber <= totalPages && (
                        <button
                            key={pageNumber}
                            onClick={() => handlePageChange(pageNumber)}
                            disabled={pageNumber === currentPage}
                        >
                            {pageNumber}
                        </button>
                    )
                );
            })}
            {currentPage < totalPages && (
                <button onClick={() => handlePageChange(currentPage + 1)}>
                    下一頁
                </button>
            )}
            {currentPage + 5 <= totalPages && (
                <button onClick={() => handlePageChange(currentPage + 5)}>
                    後五頁
                </button>
            )}
            <span>共 {totalPages} 頁</span>
        </div>
    );
}

export default Pagination; 